import styled from '@emotion/styled';
import * as React from 'react';
import { COLOR } from '@ordermentum/ui-static';

export const AuthProvidersWrapper = styled('div')`
  margin-top: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;

  button:first-child {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
  button:last-child {
    margin-left: 0.5rem;
  }
`;

export const XeroButton = () => {
  React.useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://edge.xero.com/platform/sso/xero-sso.js';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <span
      data-xero-sso
      data-href={`/session/social/xero?returnUrl=${window.location.href}`}
      data-label="Sign In with Xero"
    />
  );
};

export const GoogleButton = styled('button')`
  cursor: pointer;
  border: 0;
  outline: 0;
  width: 11.9375rem;
  height: 2.875rem;
  background-color: ${COLOR.WHITE};
  background-image: url(${process.env.IMAGE_URL}/btn-google-signin.svg);
  background-size: contain;
  background-repeat: no-repeat;
`;
